import { Link } from "wouter";
import { cn } from "@/lib/utils";
import React from "react";

interface Tab {
  id: string;
  label: string;
  href: string;
}

interface ProjectTabsProps {
  projectId: string;
  currentTab?: string;
}

export default function ProjectTabs({ projectId, currentTab = "claims" }: ProjectTabsProps) {
  
  const tabs: Tab[] = [
    { 
      id: "claims", 
      label: "Claims", 
      href: `/projects/${projectId}` 
    },
    { 
      id: "documents", 
      label: "Documents", 
      href: `/projects/${projectId}/documents` 
    },
    { 
      id: "team", 
      label: "Team", 
      href: `/projects/${projectId}/team` 
    },
  ];

  return (
    <div className="border-b border-neutral-200">
      <nav className="-mb-px flex space-x-8" aria-label="Tabs">
        {tabs.map((tab) => (
          <Link 
            key={tab.id} 
            href={tab.href}
            className={cn(
              "whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm",
              tab.id === currentTab
                ? "border-primary text-primary hover:text-primary-dark hover:border-primary-light"
                : "border-transparent text-neutral-500 hover:text-neutral-700 hover:border-neutral-300"
            )}
          >
            {tab.label}
          </Link>
        ))}
      </nav>
    </div>
  );
}
